const getIsOnlyFreeSelected = (shoppingCart = {}) => {
  let cartCounter = 0
  Object.values(shoppingCart).forEach((obj) => {
    if (Object.keys(obj).length > 0) {
      cartCounter++
    }
  })

  return !!(cartCounter === 1 && shoppingCart?.main?.free_2025)
}

module.exports = getIsOnlyFreeSelected
